import { compose, withHandlers, withState } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { getReservationTimeFromTimeItem } from '../../utils/helpers';
import WithLoader from '../../hoc/WithLoader';
import FetchOnMount from '../../hoc/FetchOnMount';
import { fetchWaitingListTimes } from '../actions';
import WaitingListTimes from '../components/WaitingListTimes';
import {
  getWaitingListTimeShopLocation,
  getWaitingListTimesBarberName,
  getWaitingListTimesDay,
  getWaitingListTimesServiceDuration,
  getWaitingListTimesServiceName,
  getWaitingListTimesShopAddress,
  getWaitingListTimesShopName,
  getWaitingListTimesShopZip,
  getWaitingListTimesTimes,
  getWaitingListTimesTimezone,
} from '../selectors';

const BOOK_TIME_SLOT = 'book-time-slot';
const REMOVE_FROM_WAITING_LIST = 'customer/waiting-list';

const WaitingListTimesContainer = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      waitingListCustomerId: ownProps.params.waitingListCustomerId,
      slotId: ownProps.params.slotId,
      barberName: getWaitingListTimesBarberName(state),
      serviceName: getWaitingListTimesServiceName(state),
      serviceDuration: getWaitingListTimesServiceDuration(state),
      shopName: getWaitingListTimesShopName(state),
      shopAddress: getWaitingListTimesShopAddress(state),
      shopZip: getWaitingListTimesShopZip(state),
      shopLocation: getWaitingListTimeShopLocation(state),
      timezone: getWaitingListTimesTimezone(state),
      day: getWaitingListTimesDay(state),
      times: getWaitingListTimesTimes(state),
      removeLink: `${REMOVE_FROM_WAITING_LIST}/${ownProps.params.waitingListCustomerId}`,
    }),
    { fetchWaitingListTimes },
  ),
  withState('isLoading', 'setIsLoading', true),
  withState('selectedTime', 'setSelectedTime', ''),
  withState('bookingLink', 'setBookingLink', ''),
  withHandlers({
    fetchData: props => () =>
      props.fetchWaitingListTimes(props.waitingListCustomerId, props.slotId).then(() => props.setIsLoading(false)),
    setTime: props => timeItem => () => {
      props.setSelectedTime(getReservationTimeFromTimeItem(timeItem));
      props.setBookingLink(`${BOOK_TIME_SLOT}/${timeItem.waitingListSlotId}/${props.waitingListCustomerId}`);
    },
  }),
  FetchOnMount,
  WithLoader,
)(WaitingListTimes);

export default WaitingListTimesContainer;



// WEBPACK FOOTER //
// ./src/app/waitingList/containers/WaitingListTimes.js